import { persianDateFormat, handleTypesName } from "./function.helper";
import { Table, Button, Popover } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

export const columns = (lang: string, handleGetExport: any) => {
  return [
    {
      title: lang === "en-US" ? "Number" : "شماره ردیف",
      dataIndex: "number",
      key: "number",
    },
    {
      title: lang === "en-US" ? "Entry & Exit" : "200 ورود 100 و خروج",
      dataIndex: "entryAndExit",
      key: "entryAndExit",
    },

    {
      title: lang === "en-US" ? "Type" : "نوع",
      dataIndex: "type",
      key: "type",
    },
    {
      title: lang === "en-US" ? "Name" : "نام محصول",
      dataIndex: "creatorEmail",
      key: "creatorEmail",
      sorter: false,
    },

    {
      title: lang === "en-US" ? "CreationTime" : "تاریخ ایجاد",
      dataIndex: "creationTime",
      key: "creationTime",
      sorter: true,
    },
    {
      title: lang === "en-US" ? "Pdf Download" : "دانلود پی دی اف",
      dataIndex: "pdf",
      key: "pdf",
      sorter: true,
      render: (id: any) => (
        <Popover content="دانلود" trigger="hover">
          <Button
            // type="primary"
            icon={
              <FilePdfOutlined style={{ fontSize: "30px", color: "#ff1b0e" }} />
            }
            onClick={() => handleGetExport(id)}
          />
        </Popover>
      ),
    },
    Table.EXPAND_COLUMN,
  ];
};

export const datahelper = (res: any, page: number) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      type: handleTypesName(item.type),
      number: index + 1 + 40 * (page - 1),
      pdf: item.id,
    };
  });
  return newData;
};
